import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

export default function FilePreviewPage() {
    const [searchParams] = useSearchParams();
    const key = searchParams.get("key");

    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        if (!key) {
            setLoading(false);
            setNotFound(true);
            return;
        }

        const url = `https://cdn.itscredible.com/issuer-data/${key}.pdf`;

        const checkFileExists = async () => {
            try {
                window.location.replace(url);
            } catch (e) {
                setNotFound(true);
                setLoading(false);
            }
        };

        checkFileExists();
    }, [key]);

    if (loading) {
        return (
            <div style={{
                width: '100dvw',
                height: '100dvh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <div>Loading...</div>
            </div>
        );
    }

    if (notFound) {
        return (
            <div style={{
                width: '100dvw',
                height: '100dvh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <span>File not found</span>
            </div>
        );
    }

    return null;
}
